/**
 * Static text tools configuration for frontend rendering.
 */

export interface TextToolDef {
  code: string;
  name: string;
  description: string;
  icon: string;
  tier: 1 | 2 | 3;
  baseCredits: number;
  placeholder: string;
}

export const TEXT_TOOLS: TextToolDef[] = [
  // Tier 1 (15-25 Credits)
  {
    code: 'text_seo_meta',
    name: 'SEO Meta Description',
    description: 'SEO-optimierte Meta-Descriptions generieren',
    icon: 'Search',
    tier: 1,
    baseCredits: 3,
    placeholder: 'Beschreibe die Seite/das Produkt, für das du eine Meta-Description brauchst...',
  },
  {
    code: 'text_social_caption',
    name: 'Social Media Caption',
    description: 'Ansprechende Social Media Captions erstellen',
    icon: 'Share2',
    tier: 1,
    baseCredits: 4,
    placeholder: 'Beschreibe den Post oder das Produkt, für das du eine Caption brauchst...',
  },
  {
    code: 'text_headline',
    name: 'Headline Generator',
    description: 'Aufmerksamkeitsstarke Headlines generieren',
    icon: 'Type',
    tier: 1,
    baseCredits: 3,
    placeholder: 'Thema oder Produkt, für das du Headlines brauchst...',
  },
  {
    code: 'text_alt_text',
    name: 'Alt-Text Generator',
    description: 'Barrierefreie Bild-Alternativtexte erstellen',
    icon: 'Image',
    tier: 1,
    baseCredits: 3,
    placeholder: 'Beschreibe das Bild, für das du einen Alt-Text brauchst...',
  },
  // Tier 2 (30-50 Credits)
  {
    code: 'text_product_desc',
    name: 'Produktbeschreibung',
    description: 'Verkaufsstarke Produktbeschreibungen generieren',
    icon: 'ShoppingBag',
    tier: 2,
    baseCredits: 10,
    placeholder: 'Produktname, Features, Zielgruppe...',
  },
  {
    code: 'text_email_copy',
    name: 'E-Mail Copy',
    description: 'Marketing-E-Mail Texte erstellen',
    icon: 'Mail',
    tier: 2,
    baseCredits: 8,
    placeholder: 'Zweck der E-Mail, Zielgruppe, Angebot...',
  },
  {
    code: 'text_ad_copy',
    name: 'Ad Copy',
    description: 'Werbetexte für verschiedene Plattformen',
    icon: 'Megaphone',
    tier: 2,
    baseCredits: 8,
    placeholder: 'Produkt/Service, Plattform (Google, Facebook, etc.), Zielgruppe...',
  },
  {
    code: 'text_rewrite',
    name: 'Text Umschreiben',
    description: 'Bestehende Texte umschreiben und verbessern',
    icon: 'RefreshCw',
    tier: 2,
    baseCredits: 8,
    placeholder: 'Füge hier den Text ein, der umgeschrieben werden soll...',
  },
  {
    code: 'text_translate',
    name: 'Text übersetzen',
    description: 'Texte natürlich in jede Sprache übersetzen',
    icon: 'Languages',
    tier: 2,
    baseCredits: 8,
    placeholder: 'Füge hier den Text ein, der übersetzt werden soll...',
  },
  // Tier 3 (60-100 Credits)
  {
    code: 'text_blog_article',
    name: 'Blog-Artikel',
    description: 'Vollständige Blog-Artikel schreiben',
    icon: 'BookOpen',
    tier: 3,
    baseCredits: 20,
    placeholder: 'Thema, Zielgruppe, gewünschte Länge, Keywords...',
  },
  {
    code: 'text_landing_page',
    name: 'Landingpage-Text',
    description: 'Conversion-optimierte Landingpage-Texte',
    icon: 'Layout',
    tier: 3,
    baseCredits: 15,
    placeholder: 'Produkt/Service, Zielgruppe, gewünschter CTA...',
  },
  {
    code: 'text_catalog_batch',
    name: 'Produktkatalog-Batch',
    description: 'Produktbeschreibungen im Batch generieren',
    icon: 'Layers',
    tier: 3,
    baseCredits: 25,
    placeholder: 'Produktliste als JSON oder CSV: Name, Features, Zielgruppe...',
  },
];

export const TIER_LABEL_KEYS: Record<number, string> = {
  1: 'textTools.tierBasis',
  2: 'textTools.tierStandard',
  3: 'textTools.tierPremium',
};

export const TIER_COLORS: Record<number, string> = {
  1: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  2: 'bg-primary-100 text-primary-800 dark:bg-primary-900/30 dark:text-primary-300',
  3: 'bg-primary-100 text-primary-800 dark:bg-primary-900/30 dark:text-primary-300',
};
